export default __webpack_public_path__ + "static/media/c001-student-6.940eefaf.jpg";